import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Single source for the tap-to-copy icon button used by template detail rows
// (replaces the copy logic duplicated in Modern's CopyValue and Minimal's MetaRow).
export default function CopyIconButton({ value, color = '#9A9A95', size = 14 }) {
    const [copied, setCopied] = React.useState(false);
    if (!value) return null;
    const copy = () => {
        try {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(String(value));
                setCopied(true);
                setTimeout(() => setCopied(false), 1400);
            }
        } catch (e) { /* clipboard unavailable */ }
    };
    return (
        <Tooltip title={copied ? 'Copied' : 'Copy'} placement="top">
            <IconButton size="small" onClick={copy} sx={{ color, p: 0.25 }}>
                <ContentCopyIcon sx={{ fontSize: size }} />
            </IconButton>
        </Tooltip>
    );
}
